import template from "./pCasemanProcessConfig.html";

export function pCasemanProcessConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanProcessConfigController,
    controllerAs: 'pCasemanProcessConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanProcessConfigController {
  constructor($scope, $location, $interval, $routeParams, $q, Auth, Caseman, Notes, Sort, Utils, bModal, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$routeParams = $routeParams;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.bModal = bModal;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";
    this.processGroupId = this.$routeParams.processGroupId;
    this.processGroupName = decodeURIComponent(this.$routeParams.processGroupName);
    this.CasemanSubcodeId = this.$routeParams.jobCodeId;
    this.CasemanJobcodeCountry = this.$routeParams.country;

    this.headers = [
      {name: "CASEMAN.PROCESS_KLIX", class: "table-info"},
      {name: "CASEMAN.SUBCODE_CASEMAN", class: "table-caseman"},
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => { this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        let promises = [
          this.Caseman.getPgProcesses(this.processGroupId),
          this.Caseman.getPgProcessesMappers(this.processGroupId),
          this.Caseman.getProcessMappers()
        ];

        this.$q.all(promises).then(
          (success) => {
            this.processesKlix = success[0].data.sort(this.Sort.abcBy("name"));
            this.processesMapper = success[1].data;
            this.customMappers = success[2].data;

            this.mapperToDisplay = this.processesKlix && this.processesKlix.map( pKlix => {
              let client = this.processesMapper && this.processesMapper.find(pMapper => pMapper.processId == pKlix.id);
              if(!client) {
                client = {processId: pKlix.id , processName: pKlix.name, subCodeId: null, subCodeName: null, unmatched: true};
              }
              return client;
            });

            this.state = "loaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  backToPGs() {
    window.history.back();
  }

  refresh() {
    this.Caseman.getPgProcessesMappers(this.processGroupId).then(
      (success) => {
        this.processesMapper = success.data;
        this.mapperToDisplay = this.processesKlix && this.processesKlix.map( pKlix => {
          let client = this.processesMapper && this.processesMapper.find(pMapper => pMapper.processId == pKlix.id);
          if(!client) {
            client = {processId: pKlix.id , processName: pKlix.name, subCodeId: null, subCodeName: null, unmatched: true};
          }
          return client;
        });
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  back() {
    window.history.back();
  }

  mappersToBeDeleted(entity) {
    return this.customMappers.filter(mapper => mapper.processId === entity.processId);
  }
  
  mappersToBeDeletedMessage(mappers) {
    var groupBy = function(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };
    
    return Object.entries(groupBy(mappers, "userName")).map(([userName, mappers]) => { return userName + " (" + mappers.map(m => m.clientName).join(", ")  + ")"; }).join("; ");
  }

  editMatch(entity) {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.processMatch = {id: entity.subCodeId, name: entity.subCodeName};
    this.Caseman.getCasemanSubcodes(this.CasemanJobcodeCountry, this.CasemanSubcodeId).then(
      (success) => {
        this.jobcodesCASEMAN = success.data.sort(this.Sort.abcBy("name")).map((jobcode)=> {
          jobcode.name = jobcode.name + " [id: " + jobcode.id + "]";
          return jobcode;
        } );
      },
      (error) => {
        this.state = "error";
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  doSaveMatch(process, subcodeToMatch, mappersToBeDeleted) {
    this.state = "loading";
    Promise.all(mappersToBeDeleted.map(m => this.Caseman.deleteProcessMatch(m.id))).then(() => {
      return this.Caseman.setPgProcessMapper(process.processId, angular.fromJson(subcodeToMatch).id);
    }).then(
      () => {
        this.processMatch = null;
        this.customMappers = this.customMappers.filter(mapper => mappersToBeDeleted.find(m => m.id == mapper.id) == undefined);
        this.refresh();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  saveMatch(process, subcodeToMatch) {
    const mappersToBeDeleted = this.mappersToBeDeleted(process);
    if (mappersToBeDeleted.length > 0) {
      this.modalConfig = {
        text: "Existing customization rules for " + process.processName + " can be overwritten: " + this.mappersToBeDeletedMessage(mappersToBeDeleted) + ". By pressing SAVE customizations made by above mentioned users will not be affected. For overwriting these customizations press SAVE & OVERWRITE.",
        cancelText: "Cancel",
        acceptText: "Save & overwrite",
        rejectText: "Save"
      };
      this.bModal.show(this.modalConfig).then(() => {
        this.doSaveMatch(process, subcodeToMatch, mappersToBeDeleted);
      }, (rejected) => {
        if (rejected) {
          this.doSaveMatch(process, subcodeToMatch, []);
        } else {
          this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        }
      });
    } else {
      this.doSaveMatch(process, subcodeToMatch, []);
    }
  }

  deleteMatch(mapper) {
    this.Caseman.deletePgProcessMapper(mapper.processId).then(
      () => {this.refresh();},
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  cancel() {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.processMatch = null;
  }

}